/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Cat_Completed_HintInputs */

const en_sch_cat_completed_hint = /** @type {(inputs: Sch_Cat_Completed_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done. Items here count as finished.`)
};

const de_sch_cat_completed_hint = /** @type {(inputs: Sch_Cat_Completed_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fertig. Vorgänge hier gelten als abgeschlossen.`)
};

/**
* | output |
* | --- |
* | "Done. Items here count as finished." |
*
* @param {Sch_Cat_Completed_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_cat_completed_hint = /** @type {((inputs?: Sch_Cat_Completed_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Cat_Completed_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_cat_completed_hint(inputs)
	return en_sch_cat_completed_hint(inputs)
});